// src/components/dashboard/AdminEventsTab.jsx
import React, { useState } from 'react';
import { eventsService } from '../../services/api';

const initialEventState = { title: '', date: new Date().toISOString().split('T')[0], location: '', description: '', active: true };

export default function AdminEventsTab({ data: events, setData: setEvents, actionLoading, setActionLoading, setError }) {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [currentEvent, setCurrentEvent] = useState(initialEventState);

    const handleSave = async (e) => {
        e.preventDefault();
        if (actionLoading) return;
        setActionLoading(true);
        setError(null);

        try {
            let result;
            if (currentEvent.id) {
                result = await eventsService.updateEvent(currentEvent.id, currentEvent);
                setEvents(prev => prev.map(e => e.id === currentEvent.id ? result.data || result : e));
            } else {
                result = await eventsService.createEvent(currentEvent);
                setEvents(prev => [...prev, result.data || result]);
            }
            setCurrentEvent(initialEventState);
            setIsFormVisible(false);
        } catch (err) {
            setError('Error al guardar el Evento.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (actionLoading) return;
        if (!window.confirm('¿Confirmas la inactivación (eliminación) de este Evento?')) return;
        
        setActionLoading(true);
        setError(null);
        try {
            await eventsService.deleteEvent(id); 
            setEvents(prev => prev.filter(e => e.id !== id));
        } catch (err) {
            setError('Error al inactivar el Evento.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleEdit = (item) => { setCurrentEvent({ ...item, date: new Date(item.date).toISOString().split('T')[0] }); setIsFormVisible(true); };
    const handleNew = () => { setCurrentEvent(initialEventState); setIsFormVisible(true); };

    return (
        <div className="mt-4">
            <h4 className="text-lg font-semibold mb-3">Gestión de Eventos</h4>
            <button onClick={handleNew} className="mb-4 btn btn-green" disabled={actionLoading}>Crear Nuevo Evento</button>

            {isFormVisible && (
                <form onSubmit={handleSave} className="mb-6 p-4 border rounded bg-gray-50 space-y-3 max-w-2xl">
                    <h5 className="font-bold">{currentEvent.id ? 'Editar Evento' : 'Nuevo Evento'}</h5>
                    
                    <input type="text" placeholder="Título" value={currentEvent.title} onChange={(e) => setCurrentEvent({ ...currentEvent, title: e.target.value })} required className="input-field" disabled={actionLoading} />
                    <input type="date" value={currentEvent.date} onChange={(e) => setCurrentEvent({ ...currentEvent, date: e.target.value })} required className="input-field max-w-[200px]" disabled={actionLoading} />
                    <input type="text" placeholder="Ubicación" value={currentEvent.location} onChange={(e) => setCurrentEvent({ ...currentEvent, location: e.target.value })} className="input-field" disabled={actionLoading} />
                    <textarea placeholder="Descripción" value={currentEvent.description} onChange={(e) => setCurrentEvent({ ...currentEvent, description: e.target.value })} rows="3" className="input-field" disabled={actionLoading} />

                    <div className="flex space-x-2">
                        <button type="submit" className="btn btn-primary" disabled={actionLoading}>{actionLoading ? 'Guardando...' : 'Guardar Evento'}</button>
                        <button type="button" onClick={() => setIsFormVisible(false)} className="btn btn-secondary" disabled={actionLoading}>Cerrar</button>
                    </div>
                </form>
            )}

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="table-th">Título</th>
                            <th className="table-th">Fecha</th>
                            <th className="table-th">Ubicación</th>
                            <th className="table-th">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {events.map((e) => (
                            <tr key={e.id}>
                                <td className="table-td">{e.title}</td>
                                <td className="table-td">{new Date(e.date).toLocaleDateString()}</td>
                                <td className="table-td">{e.location}</td>
                                <td className="table-td space-x-2">
                                    <button onClick={() => handleEdit(e)} className="text-[color:var(--primary)] hover:underline" disabled={actionLoading}>Editar</button>
                                    <button onClick={() => handleDelete(e.id)} className="text-red-600 hover:underline" disabled={actionLoading}>Eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}